var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpacityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.436,
    height: 19.436,
    viewBox: "0 0 19.436 19.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6e6e6e;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Opacity-Icon",
    className: "cls-1",
    d: "M19.436,9.718A9.724,9.724,0,1,0,13.4,18.71h.025V18.7a9.714,9.714,0,0,0,2.839-1.814h.066v-.06a9.68,9.68,0,0,0,3.107-7.108m-8.97-8.192a8.23,8.23,0,0,1,1.505.283V17.634a8.229,8.229,0,0,1-1.505.282Zm2.957.85a8.235,8.235,0,0,1,1.453.948v12.8a8.28,8.28,0,0,1-1.453.946Zm2.905,2.459a8.209,8.209,0,0,1,1.616,4.883h.006a8.2,8.2,0,0,1-1.622,4.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpacityIcon);
export default __webpack_public_path__ + "static/media/opacity_icon.d2cf419422818ef30c24b6012ea167ce.svg";
export { ForwardRef as ReactComponent };